import trivialArgsMapper from './_trivialArgsMapper';
var defaultOptions = {
  prefix: '',
  defaultMeta: undefined,
  argsMapper: trivialArgsMapper
};
export default defaultOptions;